'use client';

import clsx from "clsx";

interface SwitchProps {
    readonly checked: boolean;
    readonly onChange: (checked: boolean) => void;
    readonly label?: string;
    readonly disabled?: boolean;
    /** Variant style: 'default' uses brand colors, 'status' uses green/red */
    readonly variant?: 'default' | 'status';
}

export function Switch({ checked, onChange, label, disabled = false, variant = 'default' }: SwitchProps) {
    const getBackgroundClasses = () => {
        if (variant === 'status') {
            return checked 
                ? "border-green-500 bg-green-500" 
                : "border-red-500 bg-red-500";
        }
        return checked 
            ? "border-brand-primary bg-brand-primary/80" 
            : "border-white/20 bg-white/10";
    };

    return (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            aria-label={label}
            aria-disabled={disabled}
            disabled={disabled}
            onClick={() => !disabled && onChange(!checked)}
            className={clsx(
                "relative inline-flex h-6 w-11 items-center rounded-full border transition-colors duration-200",
                getBackgroundClasses(),
                disabled && "opacity-60 cursor-not-allowed"
            )}
        >
            <span
                className={clsx(
                    "inline-block h-4 w-4 transform rounded-full bg-white shadow transition duration-200",
                    checked ? "translate-x-5" : "translate-x-1"
                )}
            />
        </button>
    );
}
